export const DELETE_USER_ROLE_MUTATION = gql`
    mutation deleteRole($id: Int!) {
        deleteRole(id: $id) {
            id
        }
    }
`;

export const CREATE_USER_ROLE_MUTATION = gql`
    mutation createRole($input: CreateRoleInput!) {
        createRole(input: $input) {
            name
            hierarchyLevel
            permissions {
                id
                addPartner
                viewPartner
                editPartner
                changePartnerStatus
                addMerchant
                addService
                viewMerchant
                editMerchant
                cancelServices
                changeMerchantStatus
                unmaskPll
                leadManagement
                pricingAndProductManagement
                reportingExcludingFinance
                reportingIncludingFinance
                stockManagement
                viewFinance
                viewCommissions
                viewSelfBillingInvoices
                addInvoice
                addPayment
                addCredit
                partnerShop
                serviceDesk
                configurationUserManagement
                configurationAuditLog
                configurationFinance
                configurationSage
                managePartnerResources
                configurationPartnerResources
                configurationOther
                customerSuccess
                deleteApplication
                accountStatements
            }
            users {
                id
                email
            }
        }
    }
`;

export const UPDATE_USER_ROLE_MUTATION = gql`
    mutation updateRole($id: Int!, $input: UpdateRoleInput!) {
        updateRole(id: $id, input: $input) {
            name
            hierarchyLevel
            permissions {
                id
                addPartner
                viewPartner
                editPartner
                changePartnerStatus
                addMerchant
                addService
                viewMerchant
                editMerchant
                cancelServices
                changeMerchantStatus
                unmaskPll
                leadManagement
                pricingAndProductManagement
                reportingExcludingFinance
                reportingIncludingFinance
                stockManagement
                viewFinance
                viewCommissions
                viewSelfBillingInvoices
                addInvoice
                addPayment
                addCredit
                partnerShop
                serviceDesk
                configurationUserManagement
                configurationAuditLog
                configurationFinance
                configurationSage
                managePartnerResources
                configurationPartnerResources
                configurationOther
                customerSuccess
                deleteApplication
                accountStatements
            }
            users {
                id
                email
            }
        }
    }
`;
